var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88997 12.5146L1.5442 8.52239C1.29877 8.38901 1 8.56671 1 8.84602V18.1069C1 18.2393 1.07114 18.3616 1.18628 18.4271L8.5321 22.6031C8.77761 22.7427 9.08246 22.5654 9.08246 22.2829V12.8382C9.08241 12.7032 9.00857 12.579 8.88997 12.5146Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 5.1941L10.6327 1.04133C10.5257 0.985873 10.3983 0.986233 10.2917 1.04237L2.39937 5.19518C2.13736 5.33307 2.13687 5.70806 2.39856 5.84662L10.2909 10.0253C10.398 10.082 10.5261 10.0824 10.6335 10.0263L18.644 5.84765C18.9083 5.70977 18.9078 5.33136 18.6431 5.1941Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6306 8.52239L12.2848 12.5146C12.1662 12.579 12.0923 12.7032 12.0923 12.8382V22.2829C12.0923 22.5654 12.3971 22.7427 12.6427 22.6031L19.9885 18.4271C20.1036 18.3616 20.1748 18.2393 20.1748 18.1069V8.84602C20.1748 8.56671 19.876 8.38901 19.6306 8.52239Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModels);
export default __webpack_public_path__ + "static/media/models.98fa2444fc65facc98e76c95f44651bc.svg";
export { ForwardRef as ReactComponent };